import { useTranslation } from 'react-i18next';

import { CollaborationState } from '@/signalr';
import type { CollaborationStateHistoryRecord } from '@/signalr';
import { DateFormatter } from '@/features/shared/DateFormatter';

export type InvolvedAgencyCollaborationStateBadgeProps = {
  currentState: CollaborationStateHistoryRecord;
};

export function InvolvedAgencyCollaborationStateBadge({ currentState }: InvolvedAgencyCollaborationStateBadgeProps) {
  const { t } = useTranslation();

  const showBadge =
    currentState.state === CollaborationState.Invited ||
    currentState.state === CollaborationState.Accepted ||
    currentState.state === CollaborationState.Declined;

  if (!showBadge) {
    return null;
  }

  const effectiveBadgeClass =
    currentState.state === CollaborationState.Invited
      ? 'bg-warning-subtle px-1 rounded-2'
      : currentState.state === CollaborationState.Accepted
        ? 'bg-success-subtle px-1 rounded-2'
        : 'bg-danger-subtle px-1 rounded-2';

  const effectiveBadgeIcon =
    currentState.state === CollaborationState.Invited
      ? 'fal fa-question-circle'
      : currentState.state === CollaborationState.Accepted
        ? 'fal fa-check-circle'
        : 'fal fa-times-circle';

  const collaborationStateText =
    currentState.state === CollaborationState.Invited
      ? t('Incident_InvolvedAgencyStateAction_Invited')
      : currentState.state === CollaborationState.Accepted
        ? t('Incident_InvolvedAgencyState_Confirmed')
        : t('Incident_InvolvedAgencyState_Rejected');

  return (
    <div className={`${effectiveBadgeClass} row justify-content-between lh-1 mt-1 py-1`}>
      <span className="text-nowrap small text-muted w-auto">
        <i className={`${effectiveBadgeIcon} me-1`}></i>
        {collaborationStateText}
      </span>
      <span className="text-nowrap small w-auto">
        <DateFormatter date={currentState.timestampUtc} updateIntervalMs={1000} formatType="calendar" />
      </span>
    </div>
  );
}
